/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Calendar } from 'react-date-range';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid';
import { Api } from '../../api';
import { CompanyApi } from '../../api/companyApi';
import { getLocalStorageItem, useOutsideClick, errorToast } from '../../utils/helper';
import SearchInput from '../../component/common/Input/SearchInput';
import Topbar from '../PulseSurvey/Topbar';
import Breadcrumb from '../../component/common/Breadcrumb';
import { featuresHealthVideosPageData as pageData } from '../../utils/pageContent';
import VideoCard from './VideoCard';
import SelectMenu from '../../component/common/SelectMenu';
import Loader from '../../component/common/Loader';

const pages = [{ name: pageData.pageTitle, href: '/health-videos' }];

const PAGE_SIZE = 10;

const HealthVideos = () => {
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const redirectUrl = userData?.slug
    ? `/${userData?.slug}/health-videos/all`
    : `/health-videos/all`;
  const ref2 = useRef(null);
  const calendarRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen2, setIsOpen2] = useState(false);
  const [startDate, setStartDate] = useState();
  const [Id, setId] = useState('');
  const [loader, setLoader] = useState(true);
  const [categoriesList, setCategoriesList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [healthVideosList, setHealthVideosList] = useState([]);

  const handleChangeC = (e) => {
    const date = new Date(e);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setStartDate(formattedDate);
    setIsOpen2(false);
    AllHealthVideosList(1, PAGE_SIZE, searchTerm, selectedCategory, formattedDate);
  };

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  const AllHealthVideosList = (pageNumber, pageSize, searchTerm, selectedCategory, startDate) => {
    setLoader(true);
    CompanyApi.getGuidancesList(pageNumber, pageSize, searchTerm, selectedCategory, startDate).then(
      (response) => {
        if (response?.data?.meta?.code === 1) {
          setHealthVideosList(response?.data?.data);
          setLoader(false);
        } else if (response?.data?.meta?.code === 0) {
          setHealthVideosList([]);
          setLoader(false);
          errorToast(response?.data?.meta?.message);
        } else {
          setLoader(false);
        }
      }
    );
  };

  useEffect(() => {
    Api.getCategoriesById(19).then((res) => {
      setCategoriesList(
        res?.data?.data?.map((item) => {
          return {
            ...item,
            label: item?.name,
            value: item?.name
          };
        })
      );
    });
    AllHealthVideosList(1, PAGE_SIZE, searchTerm, selectedCategory, startDate);
  }, []);

  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        AllHealthVideosList(1, PAGE_SIZE, searchParam, selectedCategory, startDate);
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    }
    if (selectedCategory) {
      AllHealthVideosList(1, PAGE_SIZE, searchTerm, selectedCategory._id, startDate);
    }
  }, [searchTerm, selectedCategory]);

  return (
    <div className="relative lg:mb-[45px]">
      {loader ? <Loader /> : null}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>
      <Topbar title={pageData.pageTitle} />
      <Breadcrumb pageList={pages} className="lg:mt-8" />
      <div className="sm:flex flex-col md:flex-row mt-5 justify-between items-center gap-3">
        {/* SearchBar */}
        <div className="flex items-center justify-center w-full sm:w-auto">
          <SearchInput
            id="searchKey"
            name="searchKey"
            type="text"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            placeholder={pageData.searchPlaceholder}
            className="w-full sm:w-auto px-3 py-2"
          />
        </div>
      </div>

      <div className="sm:flex flex-col md:flex-row mt-5 justify-between nd items-center gap-3">
        <SelectMenu
          menuList={categoriesList}
          defaultSelected={selectedCategory ? selectedCategory : ''}
          label={''}
          placeholder={pageData.selectCategoryLabel}
          isRequired={false}
          setSelectedMenu={(data) => setSelectedCategory(data)}
          customClassFlag={'w-[250px]'}
        />
        {/* Date calendar */}
        <div className="flex flex-row sref2m:flex-row items-center justify-center mt-2 sm:mt-0 space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
          <div ref={ref2} className="relative inline-block text-left w-full md:w-auto mb-2 md:mb-0">
            <button
              type="button"
              onClick={() => setIsOpen2(!isOpen2)}
              className="flex justify-between items-center w-full md:w-auto px-5 py-2 text-xs md:text-base font-medium border dark:border-text-shoorah-darkBg border-[#0B1D2E] rounded-full dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
            >
              <span>
                {startDate
                  ? `${new Date(startDate).toLocaleDateString()}`
                  : pageData.dateCreatedBtnText}
              </span>
              {selectedTheme ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                    stroke="#F3F4F6"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.2802 9.9668L12.9335 14.3135C12.4202 14.8268 11.5802 14.8268 11.0669 14.3135L6.72021 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
            {isOpen2 && (
              <div
                className="absolute sm:-top-2 top-0 md:-left-96 left-0 w-full sm:w-auto transform scale-90 sm:scale-100 z-10 mt-1 p-2 bg-white shadow-lg ring-1 ring-[#E7EAE8] dark:bg-shoorah-darkBgColor rounded-md"
                ref={calendarRef}
              >
                <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                  <Calendar
                    className={'calendar text-sm sm:text-lg'}
                    onChange={handleChangeC}
                    nextLabel={
                      <button className="custom-next-button flex justify-center items-center">
                        <ChevronRightIcon className="w-8 h-8" />
                      </button>
                    }
                    maxDate={new Date()}
                    prevLabel={
                      <button className="custom-prev-button flex justify-center items-center">
                        <ChevronLeftIcon className="w-8 h-8" />
                      </button>
                    }
                    date={startDate ? new Date(startDate) : new Date()}
                    navigationLabel={({ date }) => (
                      <button
                        style={{ cursor: 'default', pointerEvents: 'none' }}
                        className="text-base"
                      >
                        {date.toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long'
                        })}
                      </button>
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedCategory && Object.keys(selectedCategory).length > 0 && (
        <div className="border py-1 px-2 mt-3">
          <div className="flex justify-between">
            <div className="self-center overflow-auto filter-container mr-2">
              <div className="flex">
                <div className="flex bg-gray-200 px-2 py-1 mr-2 whitespace-nowrap">
                  <p className="text-[14px] object-contain m-0 whitespace-nowrap">{pageData.categoryLabel}</p>
                  <p className="text-[14px] m-0 whitespace-nowrap">&nbsp;: &nbsp;</p>
                  <p className="text-[14px] m-0 whitespace-nowrap ">{selectedCategory?.name}</p>
                  <p
                    className="border cursor-pointer m-0 ml-2 self-center whitespace-nowrap"
                    onClick={() => setSelectedCategory([])}
                  >
                    <XMarkIcon className="w-[16px] border border-shoorah-primary text-white bg-shoorah-secondary" />
                  </p>
                </div>
              </div>
            </div>
            <div className="flex self-center justify-end w-[50px]">
              <button
                className="btn-primary"
                onClick={() => setSelectedCategory([])}
              >
                <XMarkIcon className="w-[18px] border-shoorah-primary text-white bg-shoorah-secondary" />
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
        <div className="flex flex-row justify-between mb-8 items-center">
          <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
            {pageData.todaysTopPicsText}
          </p>
        </div>
        <div className="h-fit gap-x-4 gap-y-6 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
          {healthVideosList?.slice(0, 3)?.map((item, index) => (
            <VideoCard
              key={index}
              item={item}
              setId={setId}
              categoriesList={categoriesList}
              Id={Id}
            />
          ))}
        </div>
        {!(healthVideosList?.length > 0) && <p className="text-center">{pageData.noVideosLabel}</p>}
      </div>

      <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
        <div className="flex flex-row justify-between mb-8 items-center">
          <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
            {pageData.allPicsText}
          </p>
          <Link
            to={redirectUrl}
            className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-active"
          >
            {pageData.viewAllBtnText}
          </Link>
        </div>
        <div className="h-fit gap-x-4 gap-y-6 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
          {healthVideosList?.slice(0, 6)?.map((item, index) => (
            <VideoCard
              key={index}
              item={item}
              setId={setId}
              categoriesList={categoriesList}
              Id={Id}
            />
          ))}
        </div>
        {!(healthVideosList?.length > 0) && <p className="text-center">{pageData.noVideosLabel}</p>}
      </div>
    </div>
  );
};

export default HealthVideos;
